import { CustomQuoteService } from 'gw-capability-quoteandbind';
import _ from 'lodash';
import { publish } from '@jutro/events';
import {
    SgSessionService,
    ADOBE_TOPICS,
    SgSessionStorageService,
    SgSubmissionUtil,
    SgAccessibilityUtils
} from 'saga-modules';

const updateCustomQuote = ((props, isAddOnChange) => {
    const {
        addon, coverages, modelVM, setQuoting, updateData, updateLobData, updateWizardSnapshot, lobAddOnCoveragePath
    } = props;
    const customQuoteDTO = {
        sessionUUID: modelVM.sessionUUID.value,
        quoteID: modelVM.quoteID.value,
        coverage: addon.patternCode,
        quote: modelVM.quoteData.offeredQuotes.value[0],
        coverages: coverages,
        phAcceptedCais: modelVM.lobData.privateMotor
            ? _.find(modelVM.lobData.privateMotor.coverables.spmDrivers.value, { isPolicyHolder: true }).hasAcceptedCAISCheck : undefined
    };

    if (!SgSessionService.handleSession(customQuoteDTO)) {
        return;
    }
    setQuoting(true);

    CustomQuoteService.updateCustomQuote(customQuoteDTO).then((customQuote) => {
        const modelCopy = _.clone(modelVM);
        if (lobAddOnCoveragePath) {
            // override addon coverages before merge when addons removed
            _.set(modelCopy.value, lobAddOnCoveragePath, _.get(customQuote, lobAddOnCoveragePath));
        }
        _.merge(modelCopy.value, customQuote);
        updateLobData(modelCopy, addon.patternCode);
        updateData(modelCopy);
        if (updateWizardSnapshot) {
            updateWizardSnapshot(modelCopy);
        }
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.MODEL, modelVM.value);
        publish(ADOBE_TOPICS.SUBMISSION_QUOTED, { model: modelCopy, isAddOnChange });
    }).finally(() => {
        setQuoting(false);
        if (isAddOnChange) {
            SgAccessibilityUtils.focusOnOriginalQuestion([`priceBox_${addon.patternCode}`]);
        }
    }).catch((err) => {
        throw err;
    });
});

const updateAddon = ((props) => {
    const {
        addon, addOnsCoverages, modelVM, updateData
    } = props;
    const isAddOnChange = true;
    const addons = addOnsCoverages.value;
    const changedAddonIndex = addons.findIndex((el) => el.patternCode === addon.patternCode);
    addons[changedAddonIndex] = addon;
    addons[changedAddonIndex].updated = true;
    addOnsCoverages.value = addons;
    updateData(modelVM);
    updateCustomQuote(props, isAddOnChange);
});

function getCoveragePrice(coverAmount, modelVM, isMonthlySelected) {
    if (isMonthlySelected === false || !SgSubmissionUtil.isMonthlyPlanSelected(modelVM)) {
        return coverAmount;
    }
    const monthlyPlan = SgSubmissionUtil.getMonthlyPaymentPlan(modelVM) || SgSubmissionUtil.getMonthlyUpfrontPaymentPlan(modelVM);
    const interestCharge = monthlyPlan.insterestCharge_Ext;
    let coverageMonthlyAmount = coverAmount / 12;
    if (interestCharge > 0) {
        coverageMonthlyAmount += (coverageMonthlyAmount * interestCharge) / 100;
    }
    coverageMonthlyAmount = Math.ceil(coverageMonthlyAmount * 100) / 100;
    return coverageMonthlyAmount;
}

function getCoverageMonthlyPrice(coverAmount, modelVM) {
    const monthlyPlan = SgSubmissionUtil.getMonthlyPaymentPlan(modelVM) || SgSubmissionUtil.getMonthlyUpfrontPaymentPlan(modelVM);
    const interestCharge = monthlyPlan.insterestCharge_Ext;
    let coverageMonthlyAmount = coverAmount / 12;
    if (interestCharge > 0) {
        coverageMonthlyAmount += (coverageMonthlyAmount * interestCharge) / 100;
    }
    coverageMonthlyAmount = Math.ceil(coverageMonthlyAmount * 100) / 100;
    return coverageMonthlyAmount;
}

export default {
    updateCustomQuote,
    updateAddon,
    getCoveragePrice,
    getCoverageMonthlyPrice
};
